import axios from 'axios';

const generateClientList = () => axios.get('/reports/generate_client_list');
const generateEntityList = () => axios.get('/reports/generate_entity_list');
const generateDeliveryReport = () =>
  axios.get('/reports/generate_delivery_report');
const generateEntityListWithConversation = () =>
  axios.get('/reports/generate_entity_list_with_conversation');
const generateAllTaxDataReport = () =>
  axios.get('/reports/generate_all_tax_data_report');
const getAllReportTemplates = () =>
  axios.get('/reports/get_all_report_templates');
const generateUsageReport = year =>
  axios.get(`/reports/generate_usage_report?year=${year}`);
const generateSignatureRequestReport = () =>
  axios.post('/reports/generate_signature_request_report');
const generateCustomReport = ({ companyId, templateName }) =>
  axios.post('/reports/generate_custom_report', {
    company_id: companyId,
    template_name: templateName,
  });
const downloadReportTemplate = reportName =>
  axios.post('/reports/download_report_template', {
    report_name: reportName,
  });
const deleteReportTemplate = reportName =>
  axios.post('/reports/delete_report_template', {
    report_name: reportName,
  });
const generateBatchCustomReport = ({ entityIds, templateName }) =>
  axios.post('/reports/generate_batch_custom_report', {
    entity_ids: entityIds,
    template_name: templateName,
  });
const uploadReportTemplate = ({ id, documentName }) =>
  axios.post('/reports/upload_report_template', {
    id,
    document_name: documentName,
  });
const generatePriorYearInformationReport = year =>
  axios.post(`/reports/generate_prior_year_information_report?year=${year}`);
const generatePriorYearItemsMatchInformationReport = year =>
  axios.post(
    `/reports/generate_prior_year_items_match_information_report?year=${year}`,
  );
const generateQuestionnaireReport = year =>
  axios.post(`/reports/generate_questionnaire_report?year=${year}`);
const generateNearlyFinishedQuestionnaireReport = (year, percentage) =>
  axios.post(
    `/reports/generate_nearly_finished_questionnaire_report?year=${year}&percentage=${percentage}`,
  );
const generateUnseenMessagesReport = () =>
  axios.get('reports/generate_unseen_messages_report');
const getTemporaryUploadLinkForReportTemplate = () =>
  axios.get('/reports/get_temporary_upload_link_for_report_template');
const downloadFolder = ({ link, name }) =>
  axios
    .post(
      '/reports/download_folder',
      {
        link,
      },
      {
        responseType: 'blob',
      },
    )
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', name + '.zip');
      document.body.appendChild(link);
      link.click();
    });
const getCreditUsage = year =>
  axios.get(`/reports/get_credit_usage?tax_year=${year}`);
export default {
  generateClientList,
  generateDeliveryReport,
  getAllReportTemplates,
  getTemporaryUploadLinkForReportTemplate,
  uploadReportTemplate,
  generateCustomReport,
  generateAllTaxDataReport,
  generateBatchCustomReport,
  downloadReportTemplate,
  downloadFolder,
  generateEntityList,
  generateEntityListWithConversation,
  deleteReportTemplate,
  generatePriorYearInformationReport,
  generateUsageReport,
  generateQuestionnaireReport,
  generateNearlyFinishedQuestionnaireReport,
  generateSignatureRequestReport,
  generatePriorYearItemsMatchInformationReport,
  generateUnseenMessagesReport,
  getCreditUsage,
};
